import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Implementación en 14 días',
  image: 'https://images.unsplash.com/photo-1506784983877-45594efa4cbe?w=600&q=80',
  desc: 'Plan de acción diario para ver resultados rápido.'
}, {
  title: 'Guía Anti-Finde',
  image: 'https://images.unsplash.com/photo-1503951914875-452162b0f3f1?w=600&q=80',
  desc: 'Cómo no terminar destruido después del sábado.'
}, {
  title: 'Protocolo Anticancelaciones',
  image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&q=80',
  desc: 'Reglas claras para que no te dejen colgado.'
}];
export function BonusSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto" data-id="element-48">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-49">
        <div className="text-center mb-12" data-id="element-50">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white uppercase flex items-center justify-center gap-3" data-id="element-51">
            <Gift className="w-8 h-8 text-amber-500" data-id="element-52" /> Bonos Exclusivos
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-53">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-zinc-900 rounded-2xl overflow-hidden border border-zinc-800 group" data-id="element-54">
              <div className="relative h-48 overflow-hidden" data-id="element-55">
                <div className="absolute top-4 left-4 z-20 bg-amber-500 text-zinc-950 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-lg" data-id="element-56">
                  GRATIS POR EL DÍA DE HOY
                </div>
                <div className="absolute inset-0 bg-zinc-950/40 group-hover:bg-transparent transition-colors duration-300 z-10" data-id="element-57" />
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-58" />
              </div>
              <div className="p-6" data-id="element-59">
                <h3 className="text-xl font-heading font-bold text-white mb-2 flex items-center gap-2" data-id="element-60">
                  <span className="text-amber-500" data-id="element-61">🎁</span> {bonus.title}
                </h3>
                <p className="text-zinc-400 text-sm" data-id="element-62">{bonus.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}